import type { PageTopProps } from '../../../react4xp/parts/pageTop/PageTopProps.d';

import React from "react";
import { PageTop } from "/react4xp/parts/pageTop/PageTop";


export default (props: Readonly<PageTopProps>): React.JSX.Element => <PageTop {...props} />;
